document.addEventListener('DOMContentLoaded', function() {

    var $slider = $('.js-announcement-carousel');

	$slider.slick({
		arrows: false,
		dots: false,
		infinite: true,
		mobileFirst: true,
		
        autoplay: true,
        autoplaySpeed: 3000,
	});

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $nextSlide = $(slick.$slides[nextSlide]);
        var delay = $nextSlide.data('delay') || slick.options.autoplaySpeed;

        slick.slickSetOption('autoplaySpeed', delay, true);
    });

})